import { extendTheme } from '@chakra-ui/react';

import colors from './colors';
import fonts from './fonts';
import shadows from './shadows';
import switchSizes from './sizes/switch';
import space from './space';
import ghostButtonVariants from './variants/GhostButton';
import icon from './variants/Icon';
import primaryButtonVariants from './variants/PrimaryButton';
import secondaryButtonVariants from './variants/SecondaryButton';
import text from './variants/Text';

export default extendTheme({
  colors,
  fonts,
  space,
  shadows,
  components: {
    Switch: {
      sizes: switchSizes,
      defaultProps: {
        colorScheme: 'primary',
      },
    },
    Text: {
      variants: text,
    },
    PrimaryButton: {
      variants: primaryButtonVariants,
    },
    SecondaryButton: {
      variants: secondaryButtonVariants,
    },
    GhostButton: {
      variants: ghostButtonVariants,
    },
    Button: {
      variants: primaryButtonVariants,
    },
    Icon: {
      variants: icon,
    },
    Tabs: {
      variants: {
        line: () => ({
          tab: {
            _selected: {
              color: colors.primary.default,
              boxShadow: 'none',
            },
          },
        }),
      },
    },
  },
  styles: {
    global: {
      'html, body': {
        heigth: '100%',
      },
    },
  },
});
